<template>
    <svg width="58" height="52" viewBox="0 0 58 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_72_2401)">
            <path
                d="M29.919 51.8482C45.0729 51.8482 57.3575 40.2416 57.3575 25.9241C57.3575 11.6066 45.0729 0 29.919 0C14.7651 0 2.48047 11.6066 2.48047 25.9241C2.48047 40.2416 14.7651 51.8482 29.919 51.8482Z"
                fill="#E5EBFF"
            />
            <path
                d="M11.5256 37.4971L2.47056 28.5557C0.96665 27.0686 0.949823 24.6455 2.43691 23.1395L6.94444 18.5752L11.5256 37.4971Z"
                fill="white"
            />
            <path
                d="M9.11012 35.0856L2.47056 28.5554C0.96665 27.0683 0.949823 24.6452 2.43691 23.1392L4.80741 20.7393"
                stroke="#525252"
                stroke-width="0.84135"
                stroke-miterlimit="10"
                stroke-linecap="round"
            />
            <path
                d="M41.9946 49.8608L15.7718 42.5284C13.7357 41.9584 12.5452 39.8466 13.1152 37.8084L22.654 3.69171C23.224 1.65564 25.3358 0.465131 27.374 1.03515L48.8978 7.0529L54.9156 17.8748L46.7145 47.2021C46.1445 49.2382 44.0327 50.4287 41.9946 49.8587V49.8608Z"
                fill="white"
                stroke="#525252"
                stroke-width="0.631012"
                stroke-linejoin="round"
            />
            <path
                d="M54.5257 17.6916L48.0872 15.8911C47.1428 15.626 46.5917 14.648 46.8546 13.7036L48.6551 7.26514L54.5257 17.6916Z"
                fill="#E5EBFF"
            />
            <path d="M28.7441 6.20068L39.953 9.33471" stroke="#A34141" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M27.8711 9.32617L36.6211 11.7724" stroke="#A34141" stroke-width="1.11479" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M26.9727 12.5298L38.1836 15.6638" stroke="#A34141" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M24.9902 19.6221L44.4191 25.053" stroke="#A34141" stroke-width="1.20313" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M23.9043 23.5117L45.243 29.4769" stroke="#A34141" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22.8164 27.4004L44.1551 33.3677" stroke="#A34141" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21.7266 31.2896L43.0653 37.2568" stroke="#A34141" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20.6387 35.1797L41.9774 41.147" stroke="#A34141" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.7773 34.4972L5.0032 18.0447C4.09875 16.1327 4.91696 13.8505 6.82893 12.9461L12.2935 10.3652L12.7773 34.4972Z" fill="white" />
            <path
                d="M11.6457 32.1063L5.0032 18.0452C4.09875 16.1332 4.91696 13.8511 6.82893 12.9466L9.48759 11.6909"
                stroke="#525252"
                stroke-width="0.84135"
                stroke-miterlimit="10"
                stroke-linecap="round"
            />
            <path
                d="M42.0799 48.1002H14.8517C12.7378 48.1002 11.0215 46.3859 11.0215 44.2699V8.84489C11.0215 6.731 12.7357 5.01465 14.8517 5.01465H37.2022L45.9102 13.8173V44.2699C45.9102 46.3838 44.1959 48.1002 42.0799 48.1002Z"
                fill="white"
                stroke="#525252"
                stroke-width="0.84135"
                stroke-linejoin="round"
            />
            <path d="M45.3575 13.7139H38.8538C37.901 13.7139 37.127 12.9399 37.127 11.987V5.4834L45.3575 13.7139Z" fill="#E5EBFF" />
            <path d="M17.5625 9.62061H29.2026" stroke="#C9D1EC" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5625 12.8682H26.6491" stroke="#C9D1EC" stroke-width="1.11479" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5625 16.1943H29.2026" stroke="#C9D1EC" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5625 19.5195H39.7194" stroke="#C9D1EC" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5625 23.5586H37.736" stroke="#C9D1EC" stroke-width="1.20313" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5625 27.5962H39.7194" stroke="#C9D1EC" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5625 31.6353H39.7194" stroke="#C9D1EC" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5625 35.6733H39.7194" stroke="#C9D1EC" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5625 39.7124H39.7194" stroke="#C9D1EC" stroke-width="1.26202" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M29.0286 32.7832C32.9643 32.7832 36.1548 29.5927 36.1548 25.657C36.1548 21.7213 32.9643 18.5308 29.0286 18.5308C25.0929 18.5308 21.9023 21.7213 21.9023 25.657C21.9023 29.5927 25.0929 32.7832 29.0286 32.7832Z"
                fill="#8C9FF8"
            />
            <path
                d="M28.6067 31.9419C32.5424 31.9419 35.7329 28.7514 35.7329 24.8157C35.7329 20.88 32.5424 17.6895 28.6067 17.6895C24.671 17.6895 21.4805 20.88 21.4805 24.8157C21.4805 28.7514 24.671 31.9419 28.6067 31.9419Z"
                stroke="#525252"
                stroke-width="0.84135"
                stroke-miterlimit="10"
            />
            <path
                d="M34.3603 21.7236L28.3804 27.7014L25.3242 24.6473"
                stroke="white"
                stroke-width="1.56281"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_72_2401">
                <rect width="56.4461" height="51.8461" fill="white" transform="translate(0.912109)" />
            </clipPath>
        </defs>
    </svg>
</template>
